<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="filterApplied">
        <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-sm-12">
                <h2>{{ 'promo.trendAndExpense' | translate }}</h2>
                <div class="chart-container">
                    <chart [options]="trendFatturatoChart.options"
                           (load)="setChartInstance(trendFatturatoChart, $event.context)"></chart>
                </div>
            </div>

            <div class="ui-g-12 ui-md-12 ui-sm-12">
                <h2>{{ 'promo.averageReceipt' | translate }}</h2>
                <div class="chart-container">
                    <chart [options]="scontrinoMedioChart.options"
                           (load)="setChartInstance(scontrinoMedioChart, $event.context)"></chart>
                </div>
            </div>
        </div>
    </div>

    <p-dialog header="Error" [(visible)]="promoError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorPromoDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/analysis/results/promo-results.component.html